// @ts-nocheck

import { colors } from '@lmc/common/constants'
import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import { ProfilePicture } from '../ProfilePicture'

export default function ResidentListItem({ link, compact, data, isActive }) {
  const textStyle = compact ? styles.linkTextCompact : styles.linkText
  const activeStyle = isActive ? styles.active : null
  const activeTextStyle = isActive ? styles.activeText : null
  const activePictureStyle = isActive ? styles.activePicture : null

  return (
    <li
      className="lmc-resident-list-item lmc-no-underline"
      key={data.id}
      style={{ ...styles.resident, ...activeStyle }}
    >
      <Link to={link || `/residents/${data.id}/profile`} style={styles.link}>
        <div style={styles.residentName}>
          <ProfilePicture
            type={compact && 'small'}
            url={data.picture}
            style={{
              ...activePictureStyle,
              ...styles.picture
            }}
          />
          <div style={{ ...textStyle, ...activeTextStyle }}>
            {data.subheading ? (
              <span>
                <span style={styles.subheading}>
                  {data.subheading} <br />
                </span>
                <span style={styles.mainText}>{data.name}</span>
              </span>
            ) : (
              data.name
            )}
          </div>
        </div>
      </Link>
    </li>
  )
}

const styles = {
  subheading: {
    opacity: 0.7,
    fontSize: 11,
    position: 'relative',
    fontWeight: 600,
    letterSpacing: 0.4,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  mainText: {
    top: -2,
    position: 'relative'
  },
  link: {
    width: '100%'
  },
  linkText: {
    position: 'relative',
    color: colors.black,
    paddingLeft: 10,
    paddingTop: 2,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  linkTextCompact: {
    top: 8,
    position: 'relative',
    color: colors.black,
    paddingLeft: 10
  },
  picture: {
    float: 'left',
    marginLeft: '3px'
  },
  resident: {
    display: 'flex',
    padding: '7px 0 7px 0px'
  },
  residentName: {},
  imageContainer: {
    height: '100%'
  },
  active: {
    background: colors.lightgrey,
    fontSize: 14,
    boxSizing: 'border-box',
    borderLeft: `3px solid ${colors.pink}`
  },
  activeText: {},
  activePicture: {
    marginLeft: 0
  }
}

ResidentListItem.propTypes = {
  data: PropTypes.object.isRequired
}
